/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc
 */
import * as References from './WorkspacesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['name'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#start
 */
export const START_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_start';
export const START_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_MUTATION_FIELD_NAME,
  args: ['initialPrompt', 'name'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.startRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#fork
 */
export const FORK_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_fork';
export const FORK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: FORK_MUTATION_FIELD_NAME,
  args: ['parentVersionId', 'prompt'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.forkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#restore
 */
export const RESTORE_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_restore';
export const RESTORE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESTORE_MUTATION_FIELD_NAME,
  args: ['versionId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.restoreRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#clone
 */
export const CLONE_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_clone';
export const CLONE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_MUTATION_FIELD_NAME,
  args: ['workspaceId', 'name'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.cloneRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getComponents
 */
export const GET_COMPONENTS_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getComponents';
export const GET_COMPONENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPONENTS_QUERY_FIELD_NAME,
  args: ['versionId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getComponentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getByProjectName
 */
export const GET_BY_PROJECT_NAME_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getByProjectName';
export const GET_BY_PROJECT_NAME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_PROJECT_NAME_QUERY_FIELD_NAME,
  args: ['projectName'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getByProjectNameRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getByConversation
 */
export const GET_BY_CONVERSATION_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getByConversation';
export const GET_BY_CONVERSATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_CONVERSATION_QUERY_FIELD_NAME,
  args: ['conversationId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getByConversationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#updateInfo
 */
export const UPDATE_INFO_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_updateInfo';
export const UPDATE_INFO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_INFO_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'appNameUserOverride', 'appDescriptionUserOverride', 'appNameOverridden', 'appDescriptionOverridden', 'iconBase64'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.updateInfoRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#delete
 */
export const DELETE_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_delete';
export const DELETE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.deleteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#publish
 */
export const PUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_publish';
export const PUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUBLISH_MUTATION_FIELD_NAME,
  args: ['versionId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.publishRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#unpublish
 */
export const UNPUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_unpublish';
export const UNPUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNPUBLISH_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.unpublishRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getPageViaId
 */
export const GET_PAGE_VIA_ID_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getPageViaId';
export const GET_PAGE_VIA_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAGE_VIA_ID_QUERY_FIELD_NAME,
  args: ['namePart', 'sort', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getPageViaIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getPageViaOffset
 */
export const GET_PAGE_VIA_OFFSET_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getPageViaOffset';
export const GET_PAGE_VIA_OFFSET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAGE_VIA_OFFSET_QUERY_FIELD_NAME,
  args: ['namePart', 'sort', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getPageViaOffsetRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#toggleFavorite
 */
export const TOGGLE_FAVORITE_MUTATION_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_toggleFavorite';
export const TOGGLE_FAVORITE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: TOGGLE_FAVORITE_MUTATION_FIELD_NAME,
  args: ['workspaceId', 'namePart', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.toggleFavoriteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getSuggestedPrompts
 */
export const GET_SUGGESTED_PROMPTS_QUERY_FIELD_NAME = 'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getSuggestedPrompts';
export const GET_SUGGESTED_PROMPTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUGGESTED_PROMPTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getSuggestedPromptsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});